import { ApiAddress } from "config";

export async function getStatistics() {
    return (await fetch(ApiAddress + "/panel")).json();
}